import React from 'react'

import { Expense } from 'core/application/employeeDashboard/summary/reimbursementRequests/getExpenses'
import { ExpenseStatus } from 'core/domain/expenses/expenseStatus'

import { parseZoneFormat } from 'common/dateFormatters'

import ExpenseDetailsItem from './ExpenseDetailsItem'
import ExpenseStatusIcon from './ExpenseStatusIcon'
import { mapExpenseStatusWithExplanationTitle } from './ExpenseStatusMapping'

interface ExpenseDetailsProps {
  expense: Expense
  translate: (key: string) => string
}

const ExpenseDetails: React.FC<ExpenseDetailsProps> = ({ expense, translate }) => {
  const getStatusValue = (): string => {
    const label = mapExpenseStatusWithExplanationTitle.get(expense.expenseStatus)
    if (label) {
      return translate(label).replace(
        '[DATE]',
        parseZoneFormat(
          expense.expenseStatus === ExpenseStatus.AwaitingReview ? expense.createdAt : expense.reviewCreatedAt,
        ),
      )
    }
    return ''
  }

  return (
    <div className="expense_details">
      <ExpenseDetailsItem
        title={translate('reimbursement-requests.date-of-service-label')}
        value={parseZoneFormat(expense.purchasedDate)}
        className="mr-64"
      />
      <ExpenseDetailsItem
        title={translate('reimbursement-requests.expense-type-label')}
        value={expense.expenseType}
        className="mr-40"
      />
      <ExpenseDetailsItem
        title={translate('reimbursement-requests.expense-for-label')}
        value={expense.familyMember}
        className="mr-40"
      />
      <ExpenseDetailsItem
        title={translate('reimbursement-requests.status-label')}
        value={getStatusValue()}
        icon={<ExpenseStatusIcon expenseStatus={expense.expenseStatus} />}
        className="mr-40"
      />
    </div>
  )
}

export default ExpenseDetails
